module.exports = __webpack_public_path__ + "img/stock6.1068cd66.png";